import gql from 'graphql-tag';

export const GET_PRODUCT = gql`
  query StaticPage($idType: ProductIdTypeEnum!, $id: ID!) {
    product(id: $id, idType: $idType) {
      ... on CompositeProduct {
        name
        compositeComponents {
          title
          databaseId
          options {
            nodes {
              name
              ... on VariableProduct {
                name
                databaseId
                price
                staticVariable {
                  individually
                }
                variations(last: 15000) {
                  nodes {
                    databaseId
                    price
                    regularPrice
                    salePrice
                    regionProductIds {
                      fieldGroupName
                      regionProductIds
                    }
                    sortIndex {
                      fieldGroupName
                      index
                    }
                    attributes(last: 15000) {
                      nodes {
                        value
                        name
                        label
                      }
                    }
                  }
                }
              }
              attributes(last: 15000) {
                nodes {
                  name
                  options
                  label
                  ... on GlobalProductAttribute {
                    terms(last: 15000) {
                      nodes {
                        name
                        slug
                        description
                        ... on PaColor {
                          id
                          name
                          sortIndex {
                            index
                          }
                        }
                        ... on PaLensThickness {
                          id
                          name
                          sortIndex {
                            index
                          }
                          priceField {
                            priceField
                            grindPriceField
                          }
                        }
                        ... on PaTreatment {
                          name
                          treatmentGroup {
                            groupName
                            groupDisplayName
                            typeGroupName
                            typeGroupDisplayName
                          }
                          sortIndex {
                            index
                          }
                          priceField {
                            priceField
                          }
                          staticVariable {
                            individually
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_BY_ID = gql`
  query StaticPage($idType: ProductIdTypeEnum!, $id: ID!) {
    product(id: $id, idType: $idType) {
			name
      ... on CompositeProduct {
        id
        name
        compositeComponents {
          title
          databaseId
          options {
            nodes {
              name
              slug
              ... on VariableProduct {
                databaseId
                name
								description
                allPaColor(last: 5000) {
                  nodes {
                    name
                    description
                    slug
                    sortIndex {
                      fieldGroupName
                      index
                    }
                  }
                }
                allPaSize(last: 5000) {
                  nodes {
                    name
                    description
                    slug
                  }
                }
                variations(last: 5000) {
                  nodes {
                    attributes {
                      nodes {
                        name
                        value
                      }
                    }
                    regionProductIds {
                      fieldGroupName
                      regionProductIds
                    }
                    image {
                      mediaItemUrl
                    }
                    price
                    regularPrice
                    salePrice
                    slug
                    databaseId
										description
                    name
                  }
                }
              }
            }
          }
        }
      }
      ... on VariableProduct {
        allPaColor(last: 15000) {
          nodes {
            name
            description
            slug
            sortIndex {
              fieldGroupName
              index
            }
          }
        }
        allPaSize(last: 15000) {
          nodes {
            name
            description
          }
        }
        variations(last: 15000) {
          nodes {
            databaseId
						description
            price
            regularPrice
            salePrice
            slug
            name
            image {
              mediaItemUrl
            }
            attributes(last: 15000) {
              nodes {
                value
                name
                label
              }
            }
            sortIndex {
              fieldGroupName
              index
            }
          }
        }
      }
    }
  }
`;

export const CONTACT_LENSES = gql`
{
  products(where: {categoryId: 143} last: 500) {
    nodes {
      ... on SimpleProduct {
        id
        name
        price
        regularPrice
        salePrice
        databaseId
        productImageList {
          productImages {
            fieldGroupName
            imagePath
          }
        }
      }
    }
  }
}`;

export const GET_PRODUCT_FEATURES = gql`
  query MyQuery {
    posts(where: {categoryName: "product-feature"}, last: 5000) {
      edges {
        node {
          id
          title
          slug
          content
          featuredImage {
            node {
              mediaItemUrl
            }
          }
          productFeatureList {
            keyPoints {
              bulletPoint
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_DETAILS = gql`
	query GetProductDetail {
  	posts(where: {categoryName: "product-detail"}, last: 1000) {
			nodes {
				title
				content(format: RENDERED)
				excerpt(format: RAW)
			}
		}
	}
`;
